/* pages.js — interactivity for the content pages (FAQ, 対応サービス, セットアップ).
   Self-contained, no dependencies. Each block no-ops when its hooks are absent,
   so this is safe to load site-wide. */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- FAQ: category filter + keyword search ---------- */
  function initFaq() {
    var nav = $("#faqNav"), list = $("#faqList"), search = $("#faqSearch");
    var count = $("#faqCount"), empty = $("#faqEmpty");
    if (!list) return;
    var groups = $$(".faq-group", list);
    var items = $$(".faq-item", list);
    var activeCat = "all";

    function apply() {
      var term = (search && search.value || "").trim().toLowerCase();
      var shown = 0;
      items.forEach(function (it) {
        var cat = it.getAttribute("data-cat");
        var key = (it.getAttribute("data-key") || it.textContent || "").toLowerCase();
        var okCat = activeCat === "all" || cat === activeCat;
        var okTerm = !term || key.indexOf(term) >= 0;
        var vis = okCat && okTerm;
        it.hidden = !vis;
        if (vis) shown++;
      });
      // hide empty groups
      groups.forEach(function (g) {
        var any = $$(".faq-item", g).some(function (it) { return !it.hidden; });
        g.hidden = !any;
      });
      if (count) count.textContent = "全" + shown + "件の質問";
      if (empty) empty.hidden = shown !== 0;
    }

    if (nav) {
      $$("button[data-cat]", nav).forEach(function (btn) {
        btn.addEventListener("click", function () {
          activeCat = btn.getAttribute("data-cat");
          $$("button[data-cat]", nav).forEach(function (b) { b.setAttribute("aria-pressed", b === btn ? "true" : "false"); });
          apply();
        });
      });
    }
    if (search) {
      search.addEventListener("input", apply);
      search.addEventListener("search", apply);
    }
    apply();
  }

  /* ---------- 対応サービス: category filter ---------- */
  function initWorksWith() {
    var filter = $("#wwFilter"), grid = $("#wwGrid");
    if (!filter || !grid) return;
    var tiles = $$(".ww-tile", grid);
    var vNote = $("#wwVerifiedNote"), sNote = $("#wwSeriesNote");
    $$("button[data-cat]", filter).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var cat = btn.getAttribute("data-cat");
        $$("button[data-cat]", filter).forEach(function (b) { b.setAttribute("aria-pressed", b === btn ? "true" : "false"); });
        tiles.forEach(function (t) {
          var tc = t.getAttribute("data-cat") || "";
          t.hidden = !(cat === "all" || tc === cat || tc.split(" ").indexOf(cat) >= 0);
        });
      });
    });
  }

  /* ---------- セットアップ: service accordion rows (.svc-row / .svc-panel) ---------- */
  function initSvcAccordion() {
    var rows = $$(".svc-item .svc-row");
    if (!rows.length) return;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    rows.forEach(function (row) {
      var item = row.closest(".svc-item");
      var panel = item ? $(".svc-panel", item) : null;
      if (!panel) return;
      panel.hidden = true;
      panel.style.maxHeight = "0px";
      row.setAttribute("aria-expanded", "false");
      var isButton = row.tagName === "BUTTON";
      if (!isButton) { row.setAttribute("role", "button"); row.setAttribute("tabindex", "0"); }
      var timer = null;
      function afterOpen() { if (item.classList.contains("is-open")) panel.style.maxHeight = "none"; }
      function afterClose() { if (!item.classList.contains("is-open")) { panel.hidden = true; panel.style.maxHeight = "0px"; } }
      // Height is animated by measuring the panel's real content height, so the
      // easing tracks the actual content (no jump from a fixed max-height cap).
      function toggle() {
        var open = !item.classList.contains("is-open");
        if (timer) { clearTimeout(timer); timer = null; }
        if (open) {
          panel.hidden = false;
          panel.style.maxHeight = "0px";
          void panel.offsetHeight;                 // reflow so the transition has a start value
          item.classList.add("is-open");
          row.setAttribute("aria-expanded", "true");
          if (reduce) { panel.style.maxHeight = "none"; return; }
          panel.style.maxHeight = panel.scrollHeight + "px";
          timer = setTimeout(afterOpen, 500);
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";   // from 'none' back to an explicit px
          void panel.offsetHeight;
          item.classList.remove("is-open");
          row.setAttribute("aria-expanded", "false");
          if (reduce) { afterClose(); return; }
          panel.style.maxHeight = "0px";
          timer = setTimeout(afterClose, 500);
        }
      }
      panel.addEventListener("transitionend", function (e) {
        if (e.propertyName !== "max-height") return;
        if (item.classList.contains("is-open")) afterOpen(); else afterClose();
      });
      row.addEventListener("click", toggle);
      if (!isButton) {
        row.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggle(); }
        });
      }
    });
  }

  function boot() { initFaq(); initWorksWith(); initSvcAccordion(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
